import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IHowToBlockProps } from './how-to-block';

const HowToBlock = lazy(async () => import('./how-to-block'));

const el = '.fa-component--how-to-block';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IHowToBlockProps;

            createRoot(component).render(<HowToBlock {...props} />);
        });
    }
};

export default {
    render,
};
